<template>
  <div class="CrmMonthReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div style="width: 260px" class="time-box flex-al fs14">
            <el-date-picker
              @change="search"
              v-model="filterList.rangeTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              :range-separator="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64e0w0')"
              :start-placeholder="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64f900')"
              :end-placeholder="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fg00')"
              size="small"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="selectChannelSearch"
              size="small"
              style="width: 180px"
              v-model="filter.client_source"
              :placeholder="$t('Report1.placeholder5')"
            >
              <el-option
                v-for="item in filterList.SchoolsourceOption"
                :key="item.frommedia_id"
                :label="item.frommedia_name"
                :value="item.frommedia_name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              size="small"
              @change="search"
              style="width: 180px"
              v-model="filter.channel_id"
              :placeholder="$t('Report1.placeholder6')"
            >
              <el-option
                v-for="item in filterList.ChannelOption"
                :key="item.channel_id"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.is_invite"
              :placeholder="$t('Analysisreport.cd')"
            >
              <el-option :label="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fks0')" value="1"></el-option>
              <el-option :label="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fpc0')" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.is_invite_arrive"
              :placeholder="$t('Analysisreport.ce')"
            >
              <el-option :label="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fks0')" value="1"></el-option>
              <el-option :label="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fpc0')" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.client_tracestatus"
              :placeholder="$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fu80')"
            >
              <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
              <!-- <el-option :label="$t('Common.options')" value></el-option> -->
              <el-option :label="$t('Report1.options[0]')" value="0"></el-option>
              <el-option :label="$t('Report1.options[1]')" value="1"></el-option>
              <el-option :label="$t('Report1.options[2]')" value="2"></el-option>
              <el-option :label="$t('Report1.options[3]')" value="3"></el-option>
              <el-option :label="$t('Report1.options[4]')" value="4"></el-option>
              <el-option
                :label="$t('Report1.options[5]')"
                value="-1"
              ></el-option>
              <el-option
                :label="$t('Report1.options[6]')"
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport.js";

export default {
  name: "analysisreport-CrmMonthReport",
  data() {
    return {
      openMenu: ["8"],
      wayString: "schoolMothReport", //传递到子组件的方法名称
      Title: this.$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fyo0'),
      placehold: "", //传递到子组件的placehold

      reportParams: {
        wayString: "schoolMothReport", //传递到子组件的方法名称
        Title: this.$t('Report.TrackAnalysis.CrmMonthReport.5zlo9o64fyo0'),
      },
      //筛选
      filter: {
        starttime: "",
        endtime: "",
        is_invite: "",
        is_invite_arrive: "",
        client_tracestatus: "",
        client_source: "",
        channel_id: "",
        keyword: "",
        coursetype_id: "", //班组
        coursecat_id: "",
      },
      // 筛选的下拉列表
      filterList: {
        rangeTime: "",
        // 招生渠道类型
        SchoolsourceOption: [],
        ChannelOption: [], // 招生渠道明细
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
        coursetypeList: [], //班组-下拉数据
        courseCatList: [],
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.getSourceData();
    this.getChannelData();
    this.filterList.rangeTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate;
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
  },
  mounted() {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http.courseTypeRecruitApi({
        coursetype_isrecruit: 1
      }).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    //获取招生渠道类型
    getSourceData() {
      http.getSource({}).then((res) => {
        this.filterList.SchoolsourceOption = res.data.data.list;
      });
    },
    //获取招生渠道明细
    getChannelData() {
      http
        .getChannel({
          channel_medianame: this.filter.client_source,
        })
        .then((res) => {
          this.filterList.ChannelOption = res.data.data.list;
        });
    },
    // 数据检索
    selectChannelSearch() {
      this.filter.channel_id = "";
      this.getChannelData(); //获取招生渠道明细
      this.search();
    },
    search() {
      this.filter.starttime = this.filterList.rangeTime
        ? this.filterList.rangeTime[0]
        : "";
      this.filter.endtime = this.filterList.rangeTime
        ? this.filterList.rangeTime[1]
        : "";
      this.$refs["reportPageTemp"].search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.CrmMonthReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
